<template>
    <div>
        <p-input type="radio" v-for="(item, key) in options" v-bind:key="key"
                 class="p-default p-round p-thick" color="success-o"
                 :name="'radio-'+ poolindex + '-' + assessmentindex"
                 :value="item.value" v-model="selected"
                 :disabled="isDisabled">{{item.text}}
        </p-input>
    </div>
</template>

<script>
    export default {
        name: "Selector",
        props: ['picked', 'poolindex', 'assessmentindex'],
        data() {
            return {
                // selected: this.picked,
                options: [
                    {id: 'one', text: '++', value: 5},
                    {id: 'two', text: '+', value: 4},
                    {id: 'tree', text: '-/+', value: 3},
                    {id: 'four', text: '-', value: 2},
                    {id: 'five', text: 'нд', value: 1}
                ]
            }
        },
        computed: {
            selected: {
                get() {
                    return this.$store.getters.POOLS[this.poolindex].assessments.body[this.assessmentindex].value
                },
                set(value) {
                    const payload = {
                        poolindex: this.poolindex,
                        assessmentindex: this.assessmentindex,
                        value: value
                    };
                    this.$store.dispatch('SAVE_ASSESSMENT', payload);
                }
            },
            isDisabled() {
                return this.$store.getters.Q_ONE.status === 1
            }
        },
        methods: {
            changeVal(value) {
                const payload = {
                    poolindex: this.poolindex,
                    assessmentindex: this.assessmentindex,
                    value: value
                };
                this.$store.dispatch('SAVE_ASSESSMENT', payload);
            }
        }
    }
</script>
<style scoped>
</style>